<template>
  <v-row align-center="center" align="center" class="stars">
    <v-spacer cols="3"></v-spacer>
    <div v-for="n in score" v-bind:key="n + '-full'">
      <v-col>
        <eva-icon name="star" fill="#222b45" height="25" width="25"></eva-icon>
      </v-col>
    </div>
    <div v-for="o in maxScore - score" v-bind:key="o + '-outline'">
      <v-col>
        <eva-icon
          name="star-outline"
          fill="#222b45"
          height="25"
          width="25"
        ></eva-icon>
      </v-col>
    </div>
    <v-spacer cols="3"></v-spacer>
  </v-row>
</template>

<script>
/**
 * Component Stars.vue
 *
 * @module Stars
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.8] app/src/APP_DASHBOARD/templates/components/Parts/Stars.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */
export default {
  name: "Stars",
  props: {
    score: {
      type: Number,
    },
    maxScore: {
      type: Number,
    },
  },
};
</script>

<style lang="scss">
</style>